'use client'

import { tva } from '@gluestack-ui/nativewind-utils/tva'
import { cssInterop } from 'nativewind'
import React from 'react'
import { ActivityIndicator } from 'react-native'

cssInterop(ActivityIndicator, {
  className: { target: 'style', nativeStyleToProp: { color: true } }
})

const spinnerStyle = tva({})

const Spinner = React.forwardRef<
  React.ComponentRef<typeof ActivityIndicator>,
  React.ComponentProps<typeof ActivityIndicator>
>(({ accessibilityLabel = 'loading', className, color, ...props }, ref) => {
  return (
    <ActivityIndicator
      accessibilityLabel={accessibilityLabel}
      ref={ref}
      {...props}
      color={color}
      className={spinnerStyle({ class: className })}
    />
  )
})

Spinner.displayName = 'Spinner'

export { Spinner }
